import i18n from 'i18next';
import { getSystemLanguage, locales } from 'lib';
import { useEffect } from 'react';
import { initReactI18next } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import NotUser from './NotUser';
import User from './User';

const Auth = (props) => {
  const user = useSelector((state) => state.user),
    appLanguage = useSelector((state) => state.appState.language),
    languageManuallySet = useSelector((state) => state.appState.languageManuallySet),
    dispatch = useDispatch();

  /*
    Resolve language PER-DEVICE.
      - If the user has explicitly picked from the dropdown on THIS
        device, honor that pick.
      - Otherwise re-detect the browser/system language on every visit
        so OS-level language changes are picked up automatically.
    We deliberately do NOT read user.language — language is device-local
    and must never sync cross-device via the user record.
  */
  const language = languageManuallySet ? appLanguage : getSystemLanguage();

  /*
    Initiate localization synchronously on first render so the very
    first paint is in the right language. Subsequent language changes
    are handled by the effect below.
  */
  if (!i18n.isInitialized) {
    i18n.use(initReactI18next).init({
      compatibilityJSON: 'v3',
      resources: locales,
      lng: language,
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false
      }
    });
  }

  /*
    Keep i18n and Redux in sync with the resolved language. Done in an
    effect (not during render) so we don't mutate Redux mid-render —
    which would warn under StrictMode and can race with i18n init.
  */
  useEffect(() => {
    if (i18n.isInitialized && i18n.language !== language) {
      i18n.changeLanguage(language);
    }
    if (language !== appLanguage) {
      dispatch({
        type: 'UPDATE_APP_STATE',
        payload: { language }
      });
    }
  }, [language, appLanguage, dispatch]);

  useEffect(() => {
    /*
      To handle events on screen size changes,
      this only fires on resize, not initial layout
    */
    window.addEventListener('resize', () => {
      dispatch({
        type: 'UPDATE_APP_STATE',
        payload: {
          isMobile: window.innerWidth < 1024
        }
      });
    });

    /*
      Set initial appState
    */
    dispatch({ type: 'SET_RESULTS' });

    /*
      Initial isMobile handler
    */
    dispatch({
      type: 'UPDATE_APP_STATE',
      payload: {
        isMobile: window.innerWidth < 1024
      }
    });
  }, []);

  return user?._id ? <User /> : <NotUser />;
};

export default Auth;
